import api from './api';

export interface PendenciaPlano {
  planoId: string;
  emendaCodigo?: string | null;
  instituicaoNome?: string | null;
  valor?: number | null;
  desde?: string | null;
  diasParado: number;
}

export interface RelatorioGestorPendente {
  gestorId: number | null;
  gestorNome: string;
  secretaria?: string | null;
  qtdPlanos: number;
  planos: PendenciaPlano[];
}

export interface RelatorioComissaoPendente {
  usuarioId: number;
  nomeCompleto: string;
  email?: string | null;
  comissaoNumero?: number | null;
  presidente: boolean;
  qtdPlanos: number;
  planos: PendenciaPlano[];
}

export interface RelatorioEmendaDevolvidaSemCiencia {
  emendaId: string;
  codigoOficial?: string | null;
  parlamentarNome?: string | null;
  valor?: number | null;
  statusCicloVida?: string | null;
  motivoDevolucao?: string | null;
  dataDevolucao?: string | null;
  diasSemCiencia: number;
}

export interface RelatorioEmendaDevolvidaComCiencia {
  emendaId: string;
  codigoOficial?: string | null;
  parlamentarNome?: string | null;
  valor?: number | null;
  statusCicloVida?: string | null;
  motivoDevolucao?: string | null;
  dataDevolucao?: string | null;
  usuarioCiencia: string;
  dataCiencia: string;
}

const downloadBlob = (blob: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const pendenciasReportService = {
  async getGestores(): Promise<RelatorioGestorPendente[]> {
    const response = await api.get('/relatorios/pendencias/gestores');
    return response.data;
  },

  async exportGestoresXlsx(): Promise<void> {
    const response = await api.get('/relatorios/pendencias/gestores/xlsx', { responseType: 'blob' });
    downloadBlob(response.data, 'pendencias-gestores.xlsx');
  },

  async exportGestoresPdf(): Promise<void> {
    const response = await api.get('/relatorios/pendencias/gestores/pdf', { responseType: 'blob' });
    downloadBlob(response.data, 'pendencias-gestores.pdf');
  },

  async getComissoes(): Promise<RelatorioComissaoPendente[]> {
    const response = await api.get('/relatorios/pendencias/comissoes');
    return response.data;
  },

  async exportComissoesXlsx(): Promise<void> {
    const response = await api.get('/relatorios/pendencias/comissoes/xlsx', { responseType: 'blob' });
    downloadBlob(response.data, 'pendencias-comissoes.xlsx');
  },

  async exportComissoesPdf(): Promise<void> {
    const response = await api.get('/relatorios/pendencias/comissoes/pdf', { responseType: 'blob' });
    downloadBlob(response.data, 'pendencias-comissoes.pdf');
  },

  async getDevolvidas(): Promise<RelatorioEmendaDevolvidaSemCiencia[]> {
    const response = await api.get('/relatorios/pendencias/devolvidas');
    return response.data;
  },

  async exportDevolvidasXlsx(): Promise<void> {
    const response = await api.get('/relatorios/pendencias/devolvidas/xlsx', { responseType: 'blob' });
    downloadBlob(response.data, 'emendas-devolvidas-sem-ciencia.xlsx');
  },

  async exportDevolvidasPdf(): Promise<void> {
    const response = await api.get('/relatorios/pendencias/devolvidas/pdf', { responseType: 'blob' });
    downloadBlob(response.data, 'emendas-devolvidas-sem-ciencia.pdf');
  },

  async getDevolvidasComCiencia(): Promise<RelatorioEmendaDevolvidaComCiencia[]> {
    const response = await api.get('/relatorios/pendencias/devolvidas-com-ciencia');
    return response.data;
  },

  async exportDevolvidasComCienciaXlsx(): Promise<void> {
    const response = await api.get('/relatorios/pendencias/devolvidas-com-ciencia/xlsx', { responseType: 'blob' });
    downloadBlob(response.data, 'emendas-devolvidas-com-ciencia.xlsx');
  },

  async exportDevolvidasComCienciaPdf(): Promise<void> {
    const response = await api.get('/relatorios/pendencias/devolvidas-com-ciencia/pdf', { responseType: 'blob' });
    downloadBlob(response.data, 'emendas-devolvidas-com-ciencia.pdf');
  },
};

export default pendenciasReportService;
